<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <search-filter
          :enableLeft="false"
          :enableDate="false"
          :enableSearch="true"
          :searchIcon="false"
          @search="params.queryKey = $event"
          placeholder="请输入姓名/手机号后4位"
          :enableFilter="false"
        />

        <div class="toolbar" v-if="config.enableAdd && app.permission.op('add_teacher')">
          <div style="color: var(--c1)" @click="toAdd()">新增老师</div>
        </div>
      </div>

      <vx-list ref="vxList" class="smain" enable :api="api" :params="params" @load="render">
        <div class="slist">
          <div
            class="sitem van-hairline--bottom"
            v-for="item in listAll"
            :key="item.id"
            @click="clickHandler2(item)"
          >
            <div class="l sicon">
              <side-icon-select :checked="ids.includes(item.id)" />
            </div>
            <div class="r">
              <!-- <img class="item-photo" :src="item.photo && item.photo.url" /> -->
              <div class="item-left">
                <div>{{ item.name }}</div>
                <div class="status-line" v-if="item.checkConflictResult !== 2">
                  <span class="tag" :class="{ 'non-empty': item.checkConflictResult === 1 }">
                    {{ item.checkConflictResult === 1 ? '冲突' : '空闲' }}
                  </span>
                  <span
                    class="to-schedule"
                    @click="toSchedule(item)"
                    v-if="item.checkConflictResult === 1 && app.permission.op('all_course_arrange')"
                  >
                    查看上课时间
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="没有找到老师哦~"
          image-size="128"
          style="margin-top: 20vh"
        ></van-empty>
      </vx-list>

      <side-foot
        @cancel="close"
        @confirm="confirm(getRet2())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          :isAll="checkAll"
          @clickAllBtn="setCheckAll"
        />
      </side-foot>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-teacher-checking',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '选择老师',
      // 是否正在加载数据
      loading: true,

      api: this.$api.arrangeGetChooseTeacherList,
      params: {
        checkConflictType: 1,
        // 场景
        scene: 0,
        queryKey: '',
        campusIds: [],
        // 要排除的老师的id
        notTeacherIds: [],
        // 在职1、离职0状态，
        statusList: [],
      },
      // 配置项
      config: {
        // 是否单选功能
        radio: false,
        // 是否必须至少选择一项
        must: false,

        // 是否开启新增老师能力
        enableAdd: false,
        // 是否开启"未分配"
        enableZero: false,
        // 显示名称
        zeroName: '未分配',
      },

      // 是否选中zeroName
      zeroIsChecked: false,
    };
  },

  methods: {
    init() {
      if (this.ids.length == 1 && this.ids[0] === 0) {
        this.zeroIsChecked = true;
      }
    },
    async render(data) {
      this.listAll = data;
      this.total = data.length;
      this.loading = false;
    },
    toAdd() {
      this.$router.push('/basePeopleAdd?type=add');
    },
    setCheckAll() {
      this.checkAll = !this.checkAll;
      this.zeroIsChecked = false;
    },
    clickHandler2(item) {
      this.zeroIsChecked = false;
      this.clickHandler(item);
    },
    getRet2() {
      if (this.zeroIsChecked) {
        this.ids = [0];
        this.list = [
          {
            id: 0,
            name: this.config.zeroName,
            logoImage: {
              width: 64,
              url: 'https://cdn01.xiaogj.com/uploads/x3/assets/img/default/avt-00.png',
              height: 64,
            },
          },
        ];
      }
      return this.getRet();
    },
    toSchedule({ id, firstConflictDate, name }) {
      let date = app.tool.date.formatDatetime(new Date(firstConflictDate), 'yyyy-MM-dd');
      this.$router.push(`/baseSchedule?showAll=true&date=${date}&tId=${id}&tName=${name}`);
    },
  },
  created() {
    this.init();
    // this.render();
    this.$onBus('people-list-refresh', () => {
      this.$refs.vxList.refresh();
    });
  },
  watch: {
    zeroIsChecked: function (nv, ov) {
      if (nv === true) {
        this.checkAll = false;
      }
    },
    // "params.queryKey": {
    //   handler: function (nv, ov) {
    //     this.render();
    //   },
    // },
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .shead {
    .toolbar {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
    }
  }
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        display: flex;
        align-items: center;
        padding: calc(var(--gap) * 12) 0;
        .l.sicon {
          margin-right: calc(var(--gap) * 12);
          padding-top: calc(var(--gap) * 2);
        }
        .r {
          flex: 1;
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          display: flex;
          align-items: center;
          background: var(--white);
          .item-photo {
            margin-right: calc(var(--gap) * 8);
            width: calc(var(--w) * 40);
            height: calc(var(--w) * 40);
            border-radius: 50%;
            background-color: var(--g5);
          }
          .item-left {
            flex: 1;
            .status-line {
              margin-top: calc(var(--gap) * 3);
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: var(--fs-sm);
              line-height: var(--lh-sm);
              .tag {
                padding: 0 calc(var(--gap) * 4);
                color: var(--c2);
                background: rgba(var(--c2-rgb), 0.12);
                border-radius: calc(var(--radius-base) * 0.5);
                &.non-empty {
                  color: var(--c3);
                  background: rgba(var(--c3-rgb), 0.12);
                }
              }
              .to-schedule {
                color: var(--tlc);
              }
            }
          }
        }
        &::after {
          margin-left: calc(var(--gap) * 38);
        }
      }
    }
    .van-loading {
      margin: 16px 0 0;
      text-align: center;
    }
  }
}
</style>